export default "__VITE_ASSET__2e0039c1__"